<ion-row class="th-text" [ngClass]="{ 'align-header-right': rightAlign }">
  {{ title }}
</ion-row>
<ion-row class="sorting-box-container">
  <ion-col
    class="sort-column"
    [ngClass]="{ 'align-dropdown-right': rightAlign }"
  >
    <div class="sort-box">
      @if (sortAddedAsc) {
        <img class="sort-icon" alt="sort-ascending" [src]="IMAGE_SRC.DESC" />
      }
      @if (!sortAddedAsc) {
        <img class="sort-icon" alt="sort-descending" [src]="IMAGE_SRC.ASC" />
      }
      <img class="sort-dropdown" alt="dropdown" [src]="IMAGE_SRC.CHEVRON" />
    </div>
  </ion-col>
</ion-row>
